import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {BreadCrumbStrip} from '../../form-components/BreadCrumbStrip.component';
import {TabPanel} from '../../form-components/TabPanel.component';
import TabItem from '../../../@types/tab-item';
import {ResourceType} from '../../../@types/resource-type';
import {getEditorConfig} from './tab-editor-config';

interface EditorContainerProps {
    tab: TabItem;
    isActive: boolean;
    currentIndex: number;
    onUpdate: (tabObject: { objectType: ResourceType, object: any }) => void;
    componentId: string;
}

/**
 * EditorContainer component manages rendering of the appropriate editor based on resource type
 */
export const EditorContainer: React.FC<EditorContainerProps> = ({ 
    tab, 
    isActive, 
    currentIndex,
    onUpdate,
    componentId 
}) => {
    const renderEditor = (): React.ReactElement | null => {
        const config = getEditorConfig(tab.type);
        if (!config) {
            return null;
        }

        const EditorComponent = config.component;
        const preparedObject = config.prepareObject ? config.prepareObject(tab.objectToEdit) : tab.objectToEdit;
        
        const props: any = {
            isActive: isActive,
            updateTab: onUpdate,
            resourceType: tab.type,
        };

        if (config.propName) {
            props[config.propName] = preparedObject;
        }

        return <EditorComponent {...props} />;
    };

    return (
        <TabPanel
            value={currentIndex}
            index={tab.index}
            ownerId={`tab-editor-tab-${componentId}-${tab.index}`}
        >
            <Stack spacing={2} sx={{ height: '100%' }}>
                <BreadCrumbStrip breadCrumbs={tab.breadCrumbs} />
                <Box sx={{ flex: 1, minHeight: 0 }}>
                    {renderEditor()}
                </Box>
            </Stack>
        </TabPanel>
    );
};